"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ImageSelection = function (_a) {
    var onSelectImage = _a.onSelectImage, handleNext = _a.handleNext;
    var _b = (0, react_1.useState)(null), selectedImage = _b[0], setSelectedImage = _b[1];
    var base = document.getElementById('seedcard').getAttribute('data-base');
    var images = JSON.parse(document.getElementById('seedcard').getAttribute('data-images'));
    var tweenFactor = 50;
    var handleImageSelect = function (image) {
        setSelectedImage(image);
        images.map(function (img, index) {
            var _a, _b;
            if (img !== image) {
                window.setTimeout(function () {
                    var _a, _b;
                    (_a = document.getElementById('image-' + index)) === null || _a === void 0 ? void 0 : _a.classList.remove('fadeIn');
                    (_b = document.getElementById('image-container-' + index)) === null || _b === void 0 ? void 0 : _b.classList.add('fadeOut');
                }, index % 6 * tweenFactor);
            }
            else {
                (_a = document.getElementById('image-container-' + index)) === null || _a === void 0 ? void 0 : _a.classList.add('animate__animated');
                (_b = document.getElementById('image-container-' + index)) === null || _b === void 0 ? void 0 : _b.classList.add('animate__bounceOut');
            }
        });
        window.setTimeout(function () {
            onSelectImage(image);
            handleNext();
        }, images.length / 6 * tweenFactor + 500);
    };
    return (react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
        images.map(function (image, index) { return (react_1.default.createElement(material_1.Grid, { item: true, xs: 6, md: 3, lg: 2, key: index, id: 'image-container-' + index },
            react_1.default.createElement(material_1.Card, null,
                react_1.default.createElement(material_1.Box, { id: 'image-' + index, className: "displayNone" },
                    react_1.default.createElement(material_1.CardActionArea, { onClick: function () { return handleImageSelect(image); } },
                        react_1.default.createElement(material_1.CardMedia, { component: "img", height: "160px", image: base + image.replace('/seedcards/', '/seedcards/thumbnails/') }))),
                react_1.default.createElement(material_1.Box, { id: 'skeleton-' + index },
                    react_1.default.createElement(material_1.CardMedia, { component: material_1.Skeleton, height: "160px", variant: "rounded", animation: "wave" }),
                    react_1.default.createElement(material_1.Box, { component: "img", src: base + image.replace('/seedcards/', '/seedcards/thumbnails/'), className: "displayNone", onLoad: function () {
                            window.setTimeout(function () {
                                var _a, _b;
                                (_a = document.getElementById('skeleton-' + index)) === null || _a === void 0 ? void 0 : _a.classList.add('displayNone');
                                (_b = document.getElementById('image-' + index)) === null || _b === void 0 ? void 0 : _b.classList.remove('displayNone');
                            }, index % 6 * tweenFactor);
                        } }))))); }),
        images.map(function (image, index) { return (react_1.default.createElement(material_1.Box, { key: index, component: "img", src: base + image, className: "displayNone" })); })));
};
exports.default = ImageSelection;
